import React from 'react';
import CertificationContainer from 'Containers/Certification';
import useTenantFlags from 'hooks/useTenantFlags';

const Certificacion = () => {
  const { minvuEnabled } = useTenantFlags();
  // Página de certificaciones MINVU (ASIMET): oculta para tenants con MINVU off.
  if (!minvuEnabled) return null;
  return (
    <div>
      <CertificationContainer />
    </div>
  );
};

export default Certificacion;
